// The /transcripts empty-state selector (transcripts.md): filtered → adjust
// filters; agent scope → connection check + a link to the Simulations launch
// route; zero agents → the first-run spine; else the team-wide prompt. A
// pending first-run probe renders nothing so the wrong empty state never
// flashes.
import { Button, EmptyState, RouterLink } from "../../ui";
import { ConnectionCheckLauncher } from "./ConnectionCheckLauncher";
import { FirstRunSpine } from "./FirstRunSpine";

export interface TranscriptsEmptyStateProps {
  agentId?: string;
  hasActiveFilters: boolean;
  hasZeroAgents: boolean;
  isFirstRunProbePending: boolean;
  onClearFilters: () => void;
}

export function TranscriptsEmptyState({
  agentId,
  hasActiveFilters,
  hasZeroAgents,
  isFirstRunProbePending,
  onClearFilters,
}: TranscriptsEmptyStateProps) {
  // Filtered-empty is a distinct state from list-empty: it never offers the
  // first-run CTA, and it hands back the only useful action — drop the
  // filters (§4c).
  if (hasActiveFilters) {
    return (
      <EmptyState
        action={
          <Button size="md" variant="secondary" onClick={onClearFilters}>
            Clear filters
          </Button>
        }
        title="No matching transcripts"
      />
    );
  }
  if (agentId !== undefined) {
    return (
      <EmptyState
        action={<ConnectionCheckLauncher agentId={agentId} />}
        description={
          <>
            For a full batch run,{" "}
            <RouterLink search={{ agent: agentId }} to="/simulations/new">
              launch a simulation
            </RouterLink>
            .
          </>
        }
        title="No transcripts"
      />
    );
  }
  if (hasZeroAgents) {
    return <FirstRunSpine />;
  }
  if (isFirstRunProbePending) {
    return null;
  }
  return <EmptyState title="No transcripts" />;
}
